import { ContentArea } from '@calendly/ui/components/content-area';
import { ReactNode, useCallback } from 'react';
import { SHELL_CONTENT_SCROLL_ELEMENT_ID } from 'shared/constants/app_shell';
import { setShellContentScrollElement } from 'shared/shell_content_scroll_registry';
import { useCenterPanelLayoutContext } from './centerPanelLayoutContext';
const centerPanelScrollCss = "c1bm7r8z";

/**
 * Scrollable center column between top and bottom chrome in `#shell-content`.
 * Scroll lives here, not on `#shell-content`. Layout mode is driven by `useCenterPanelLayout`.
 */
export const CenterPanelContent = ({
  children
}: {
  children: ReactNode;
}) => {
  const {
    layout
  } = useCenterPanelLayoutContext();
  const setShellContentScrollRef = useCallback((node: HTMLDivElement | null) => {
    setShellContentScrollElement(node);
  }, []);
  return <div ref={setShellContentScrollRef} id={SHELL_CONTENT_SCROLL_ELEMENT_ID} className={centerPanelScrollCss} tabIndex={0} role="region" aria-label="Main content">
      <ContentArea id="shell-content-slot" isWide={layout === 'wide'}>
        {children}
      </ContentArea>
    </div>;
};

require("./CenterPanelContent.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CenterPanelContent.tsx");